import { useEffect } from 'react'
import { clearMediaSession } from 'src/utils/clearMediaSession'

export const useClearMediaSession = () => {
  useEffect(() => {
    clearMediaSession()
  }, [])
}
